var _dec, _dec2, _dec3, _dec4, _class, _class2;
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
import { classNames, attributeBindings, tagName } from '@ember-decorators/component';
import { observes } from '@ember-decorators/object';
import Component from '@ember/component';
import '@ember/object';
import { isNone } from '@ember/utils';
import afterRender from '@customerio/fly-components/utils/after-render';
let FlyMenuList = (_dec = tagName('ul'), _dec2 = classNames('fly-menu-list'), _dec3 = attributeBindings('role'), _dec4 = observes('focusedItem'), _dec(_class = _dec2(_class = _dec3(_class = (_class2 = class FlyMenuList extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "role", 'menu');
    /**
      The available items to display in the menu.
       @public
      @property items
      @type Array
      @default null
    */
    _defineProperty(this, "items", null);
    /**
      The focused item in the menu.
       @public
      @property focusedItem
      @type Integer, Object, String
      @default null
    */
    _defineProperty(this, "focusedItem", null);
  }
  /**
    Scroll an item into view.
     @private
    @method _scrollToItem
    @param {Integer,String,Object} item the item to scroll into view
    @param {Options} [options]
      @param {Boolean} [options.center=undefined]
        attempt to scroll the item to the center
  */
  _scrollToItem(item, options = {}) {
    let {
      center
    } = options;
    let {
      items
    } = this;
    if (isNone(item) || !items) {
      return;
    }
    let itemIndex = items.indexOf(item);
    if (itemIndex === -1) {
      return;
    }
    let list = this.element;
    if (center) {
      let itemHeight = this.element.querySelectorAll(`.fly-menu-item`)[itemIndex].offsetHeight;
      let centerPosForItem = this._itemTop(itemIndex) - list.offsetHeight / 2 + itemHeight / 2;
      afterRender(() => {
        list.scrollTop = centerPosForItem;
      });
    } else {
      afterRender(() => {
        list.scrollTop = this._scrollPosForItem(itemIndex);
      });
    }
  }

  /**
    Calculate the scroll position for an item to be completely visible
     @private
    @method _scrollPosForItem
    @param {Integer} itemIndex the index of the item in the items array
    @return {Number} position
  */
  _scrollPosForItem(itemIndex) {
    let item = this.element.querySelectorAll(`.fly-menu-item`)[itemIndex];
    let list = this.element;
    let itemHeight = item.offsetHeight;
    let itemTop = this._itemTop(itemIndex);
    let itemBottom = itemTop + itemHeight;
    let scrollPos = list.scrollTop;
    let listHeight = list.offsetHeight;
    let listBottom = scrollPos + listHeight;
    if (itemTop < scrollPos) {
      return itemTop;
    } else if (itemBottom > listBottom) {
      return itemBottom - listHeight;
    } else {
      // Must already be in view
      return scrollPos;
    }
  }

  /**
    Calculates the number of pixels from the top of the
    list for an item at the specified index. The sum of all
    preceeding items are used to determine the value.
     @private
    @method _itemTop
    @param {Integer} itemIndex the index of the item in the items array
    @return {Number} top
  */
  _itemTop(itemIndex) {
    let itemHeightSum = 0;
    this.element.querySelectorAll('.fly-menu-item').forEach((element, index) => {
      if (index < itemIndex) {
        itemHeightSum += element.offsetHeight;
      }
    });
    return itemHeightSum;
  }
  _focusedItemDidChange() {
    let {
      focusedItem
    } = this;
    this._scrollToItem(focusedItem);
  }
  didInsertElement() {
    super.didInsertElement(...arguments);
    this._scrollToItem(this.focusedItem, {
      center: true
    });
  }
  willDestroyElement() {
    super.willDestroyElement(...arguments);
  }
}, (_applyDecoratedDescriptor(_class2.prototype, "_focusedItemDidChange", [_dec4], Object.getOwnPropertyDescriptor(_class2.prototype, "_focusedItemDidChange"), _class2.prototype)), _class2)) || _class) || _class) || _class);
export { FlyMenuList as default };